<template>

    <div class="field">
        <label class="label" v-if="props.etichetta">{{ props.etichetta }}</label>
        <div class="field has-addons">
            <!-- <div class="control" v-if="props.testo">
                <input class="input" type="text" v-model="descrizioneTesto"
                    :placeholder="props.testo"
                    :disabled="props.solaLettura" @change="modificaDescrizione()">
            </div> -->
            <div class="control"  v-for="(vl, index) in valoreNumero" :key="vl">
                <input class="input has-text-centered" type="text"
                    v-model=valoreTesto[index]
                    :placeholder=valoreTesto[index]
                    :disabled=props.solaLettura
                    @change="elementoModifica(valoreTesto[index], index)">
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref } from "vue";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        valore: {
            type: Object,
            default: () => ({})
        },
        identificativo: {
            type: String,
            default: ''
        },
        etichetta: {
            type: String,
            default: null
        },
        solaLettura: {
            type: Boolean,
            default: false
        }
    });
    const emit = defineEmits(['valoreCambiato']);

    // VARIABILI DEL COMPONENTE
    const valoreTesto = ref([]);
    const valoreNumero = ref([]);

    // SETUP DEL COMPONENTE
    setupForm();

    // FUNZIONI DEL COMPONENTE
    function setupForm() {
        for (let i in props.valore) {
            if (props.valore[i]!=null){
                valoreNumero.value.push(props.valore[i]);
                valoreTesto.value.push(parseInt(props.valore[i]*100).toString()+' %');
            } else {
                valoreNumero.value.push(0);
                valoreTesto.value.push('');
            }
        }
    }

    function elementoModifica(val, indice) {
        // Converte il testo val in un valore numerico mantenendo solo i numeri, la virgola e il segno meno (per i numeri negativi)
        let valore = props.valore;
        valore[indice] = parseFloat(val.replace(/[^0-9.-]/g, '').replace(/(?!^)-/g, '')) / 100;
        if (!valore[indice]) valore[indice] = 0;
        emit('valoreCambiato', valore, props.identificativo);
    }

    // function modificaDescrizione() {
    //     emit('valoreCambiato', descrizioneTesto, props.identificativoTesto);
    //     setupForm();
    // }

</script>